import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import GrowthLinkEditor from './GrowthLinkEditor.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/growth-links'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'growth_links_wrapper',
          meta: { permissions: ['administrator'] },
          redirect: to => ({ name: 'growth_links_list', params: to.params }),
        },
        {
          path: 'list',
          name: 'growth_links_list',
          meta: { permissions: ['administrator'] },
          component: Index,
        },
        {
          path: 'new',
          name: 'growth_links_new',
          meta: { permissions: ['administrator'] },
          component: GrowthLinkEditor,
        },
        {
          path: ':linkId/edit',
          name: 'growth_links_edit',
          meta: { permissions: ['administrator'] },
          component: GrowthLinkEditor,
          props: route => ({ linkId: route.params.linkId }),
        },
      ],
    },
  ],
};
